var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.156 8.66675H33.8427C18.0693 8.66675 8.66602 18.0701 8.66602 33.8434V70.1134C8.66602 85.9301 18.0693 95.3334 33.8427 95.3334H70.1127C85.886 95.3334 95.2894 85.9301 95.2894 70.1568V33.8434C95.3327 18.0701 85.9294 8.66675 70.156 8.66675Z",
    fill: "#29CD3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8462 67.5133C44.9796 67.5133 44.1562 67.1666 43.5496 66.5599L31.2862 54.2966C30.0296 53.0399 30.0296 50.9599 31.2862 49.7033C32.5429 48.4466 34.6229 48.4466 35.8796 49.7033L45.8462 59.6699L68.1196 37.3966C69.3762 36.1399 71.4562 36.1399 72.7129 37.3966C73.9696 38.6533 73.9696 40.7333 72.7129 41.9899L48.1429 66.5599C47.5362 67.1666 46.7129 67.5133 45.8462 67.5133Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.42238d1fff75fceaee54ff4aa58cb82a.svg";
export { ForwardRef as ReactComponent };